// Recopie des règlements Polaris pour une liste de pièces. Les accès (lecture Polaris,
// écriture CIME) sont injectés pour pouvoir tester l'enchaînement seul.
import {
  polarInvoiceToPaymentSync,
  shouldSyncPayments,
  type PaymentSync,
  type PolarInvoicePayments,
} from './polarPayments';

export interface SyncableDoc {
  id: string;
  doc_type: string;
  status: string;
  polar_invoice_id: string | null;
  number: string | null;
}

export interface SyncDeps {
  fetchInvoice: (polarInvoiceId: string) => Promise<PolarInvoicePayments>;
  save: (documentId: string, sync: PaymentSync) => Promise<unknown>;
}

export interface SyncResult {
  synced: number;
  failed: number;
  /** Polaris n'a pas répondu : la copie actuelle reste la dernière connue. */
  unreachable: boolean;
}

const CONCURRENCY = 3;

export async function syncPolarPayments(docs: SyncableDoc[], deps: SyncDeps): Promise<SyncResult> {
  const queue = docs.filter(shouldSyncPayments);
  const result: SyncResult = { synced: 0, failed: 0, unreachable: false };

  async function worker() {
    for (let doc = queue.shift(); doc; doc = queue.shift()) {
      try {
        const invoice = await deps.fetchInvoice(doc.polar_invoice_id!);
        await deps.save(doc.id, polarInvoiceToPaymentSync(invoice));
        result.synced += 1;
      } catch (err) {
        result.failed += 1;
        if ((err as { code?: string }).code === 'polar_unreachable') result.unreachable = true;
      }
    }
  }

  await Promise.all(Array.from({ length: Math.min(CONCURRENCY, queue.length) }, worker));
  return result;
}
